import React, { useState } from "react";

import Grid from "@mui/material/Grid";

import { Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { Worker } from "@react-pdf-viewer/core";

import es_ES from "@react-pdf-viewer/locales/lib/es_ES.json";

const Visorpdf = (props) => {
  // Create new plugin instance
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const [defaultPdf] = useState(props.url);

  return (
    <>
      <Grid>
        <Grid item xs={12}>
          {defaultPdf && (
            <>
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                <Viewer
                  fileUrl={defaultPdf}
                  plugins={[defaultLayoutPluginInstance]}
                  localization={es_ES}
                />
              </Worker>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Visorpdf;
